// Helper functions for tail stripes
function getPointOnQuadraticBezier(t: number, x0: number, y0: number, x1: number, y1: number, x2: number, y2: number) {
    const invT = 1 - t;
    const x = invT * invT * x0 + 2 * invT * t * x1 + t * t * x2;
    const y = invT * invT * y0 + 2 * invT * t * y1 + t * t * y2;
    return { x, y };
}

function getNormalOnQuadraticBezier(t: number, x0: number, y0: number, x1: number, y1: number, x2: number, y2: number) {
    const dx = 2 * (1 - t) * (x1 - x0) + 2 * t * (x2 - x1);
    const dy = 2 * (1 - t) * (y1 - y0) + 2 * t * (y2 - y1);
    const length = Math.sqrt(dx * dx + dy * dy);
    return { x: -dy / length, y: dx / length };
}

const drawSussieOnDerpy = (ctx: CanvasRenderingContext2D) => {
    ctx.save();
    // Position Sussie on Derpy's head
    ctx.translate(0, -35);
    ctx.scale(0.25, 0.25);

    // Body
    ctx.fillStyle = "#fff";
    ctx.beginPath();
    ctx.ellipse(0, 0, 30, 40, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = "#111";
    ctx.beginPath();
    ctx.ellipse(0, -20, 30, 25, 0, Math.PI, 0);
    ctx.fill();

    // Wings with target pattern
    const drawWing = (side: number) => {
        ctx.save();
        ctx.scale(side, 1);
        ctx.translate(25, -5);

        ctx.fillStyle = "#111";
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.quadraticCurveTo(20, -20, 30, 10);
        ctx.quadraticCurveTo(10, 15, 0, 0);
        ctx.fill();

        ctx.strokeStyle = "#fff";
        ctx.lineWidth = 4;
        ctx.beginPath(); ctx.arc(15, 0, 10, 0, Math.PI * 2); ctx.stroke();
        ctx.fillStyle = "#fff";
        ctx.beginPath(); ctx.arc(15, 0, 3, 0, Math.PI * 2); ctx.fill();

        ctx.restore();
    };
    drawWing(1);
    drawWing(-1);
    
    // Tail
    ctx.fillStyle = "#111";
    ctx.beginPath();
    ctx.moveTo(0, 40);
    ctx.quadraticCurveTo(10, 50, 0, 60);
    ctx.quadraticCurveTo(-10, 50, 0, 40);
    ctx.fill();

    // Head
    ctx.translate(0, -40);
    ctx.fillStyle = "#111";
    ctx.beginPath();
    ctx.ellipse(0, 0, 15, 20, 0, 0, Math.PI * 2);
    ctx.fill();

    // Beak
    ctx.beginPath();
    ctx.moveTo(0, -5);
    ctx.lineTo(-20, 0);
    ctx.lineTo(0, 5);
    ctx.fill();
    
    // Eyes (glowing)
    ctx.fillStyle = "#facc15"; // Yellow-400
    ctx.shadowColor = "#facc15";
    ctx.shadowBlur = 10;
    ctx.beginPath(); ctx.arc(-5, -5, 4, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(-5, 5, 4, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(-5, 15, 4, 0, Math.PI * 2); ctx.fill();
    ctx.shadowBlur = 0;

    // Gat Hat
    ctx.fillStyle = "#111";
    ctx.beginPath();
    ctx.ellipse(0, -18, 18, 4, 0, 0, Math.PI * 2); // Brim
    ctx.fill();
    ctx.fillRect(-8, -35, 16, 17); // Crown

    ctx.restore();
};

export const drawDerpyAndSussieInHub = (ctx: CanvasRenderingContext2D) => {
    ctx.save();

     // --- Draw the knocked over pot, based on lore ---
    ctx.save();
    ctx.translate(40, 80); // Position relative to Derpy's center
    ctx.rotate(Math.PI / 2.2);

    // Spilled dirt
    ctx.fillStyle = '#5f3f2f';
    ctx.beginPath();
    ctx.ellipse(-10, 20, 15, 8, -Math.PI / 4, 0, Math.PI * 2);
    ctx.fill();
    
    // Pot body
    ctx.fillStyle = '#a16207'; 
    ctx.beginPath();
    ctx.moveTo(-10, 15); ctx.lineTo(10, 15); ctx.lineTo(15, -15); ctx.lineTo(-15, -15);
    ctx.closePath();
    ctx.fill();
    
    // Pot rim
    ctx.fillStyle = '#c2410c';
    ctx.fillRect(-17, -20, 34, 5);
    ctx.restore();

    // Spirit Glow
    ctx.shadowBlur = 30;
    ctx.shadowColor = "#38bdf8"; // sky-400

    // Body
    const bodyGrad = ctx.createRadialGradient(0, 0, 0, 0, 0, 90);
    bodyGrad.addColorStop(0, "#7dd3fc"); // sky-300
    bodyGrad.addColorStop(1, "#0ea5e9"); // sky-500
    ctx.fillStyle = bodyGrad;
    ctx.beginPath();
    ctx.ellipse(0, 0, 70, 85, 0, 0, Math.PI * 2);
    ctx.fill();

    // Rosettes on chest
    ctx.fillStyle = "rgba(15, 23, 42, 0.4)"; // slate-900
    const drawRosette = (x: number, y: number, size: number) => {
        ctx.beginPath(); ctx.arc(x, y, size, 0, Math.PI * 2); ctx.fill();
    };
    drawRosette(20, 30, 8);
    drawRosette(-15, 45, 6);
    drawRosette(35, 50, 5);
    
    // Paws
    ctx.fillStyle = "#0ea5e9";
    ctx.beginPath(); ctx.roundRect(-50, 70, 40, 20, 10); ctx.fill();
    ctx.beginPath(); ctx.roundRect(10, 70, 40, 20, 10); ctx.fill();
    ctx.fillStyle = "#0284c7";
    ctx.fillRect(-45, 85, 10, 2); ctx.fillRect(-30, 85, 10, 2);
    ctx.fillRect(15, 85, 10, 2); ctx.fillRect(30, 85, 10, 2);

    // Head
    ctx.save();
    ctx.translate(0, -60);
    
    // Ears
    ctx.fillStyle = "#0ea5e9";
    ctx.beginPath(); ctx.moveTo(-25, -15); ctx.lineTo(-45, -40); ctx.lineTo(-30, -5); ctx.fill();
    ctx.beginPath(); ctx.moveTo(25, -15); ctx.lineTo(45, -40); ctx.lineTo(30, -5); ctx.fill();
    
    // Head shape
    ctx.fillStyle = bodyGrad;
    ctx.beginPath();
    ctx.ellipse(0, 0, 50, 45, 0, 0, Math.PI * 2);
    ctx.fill();

    // Stripes on head
    ctx.fillStyle = "rgba(15, 23, 42, 0.6)";
    ctx.beginPath(); ctx.moveTo(-20, -42); ctx.quadraticCurveTo(-10, -30, -15, -20); ctx.fill();
    ctx.beginPath(); ctx.moveTo(20, -42); ctx.quadraticCurveTo(10, -30, 15, -20); ctx.fill();
    ctx.beginPath(); ctx.moveTo(0, -45); ctx.lineTo(-2, -35); ctx.lineTo(2, -35); ctx.fill();

    // Eyes
    ctx.fillStyle = "#fef08a"; // yellow-200
    ctx.beginPath(); ctx.ellipse(-18, -5, 12, 16, 0.1, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(18, -5, 12, 16, -0.1, 0, Math.PI * 2); ctx.fill();
    
    // Iris
    ctx.fillStyle = "#f87171"; // red-400
    ctx.beginPath(); ctx.arc(-16, -3, 8, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(20, -3, 8, 0, Math.PI * 2); ctx.fill();
    
    // Pupils
    ctx.fillStyle = "#1e293b"; // slate-800
    ctx.beginPath(); ctx.arc(-18, -3, 4, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(18, -3, 4, 0, Math.PI * 2); ctx.fill();

    // Mouth / Grin
    ctx.beginPath();
    ctx.moveTo(-25, 15);
    ctx.quadraticCurveTo(0, 35, 25, 15);
    ctx.quadraticCurveTo(0, 25, -25, 15);
    ctx.fillStyle = "#1e293b";
    ctx.fill();

    // Teeth
    ctx.fillStyle = "#fff";
    for(let i=0; i < 8; i++) {
        const x = -18 + i * 5;
        const y = 17 + (i%2 === 0 ? 0 : 3);
        ctx.beginPath();
        ctx.moveTo(x-1.5, y); ctx.lineTo(x+1.5, y); ctx.lineTo(x, y+4);
        ctx.fill();
    }
    
    // Tusks
    ctx.beginPath(); ctx.moveTo(-24, 15); ctx.quadraticCurveTo(-20, 25, -18, 15); ctx.fill();
    ctx.beginPath(); ctx.moveTo(24, 15); ctx.quadraticCurveTo(20, 25, 18, 15); ctx.fill();

    // Nose
    ctx.fillStyle = "#f472b6"; // pink-400
    ctx.beginPath();
    ctx.moveTo(0, 5); ctx.lineTo(-5, 12); ctx.lineTo(5, 12); ctx.closePath();
    ctx.fill();
    
    // Draw Sussie
    drawSussieOnDerpy(ctx);
    
    ctx.restore(); // Head translate

    // Tail
    ctx.save();
    ctx.translate(-60, 50);
    ctx.rotate(0.2);
    ctx.strokeStyle = "#0284c7";
    ctx.lineWidth = 15;
    ctx.lineCap = "round";
    ctx.beginPath();
    ctx.moveTo(0,0);
    ctx.quadraticCurveTo(20, -50, -10, -80);
    ctx.stroke();

    // Tail Stripes
    ctx.strokeStyle = "#1e293b";
    ctx.lineWidth = 5;
    for (let i = 0; i < 5; i++) {
        const t = i / 4;
        const p = getPointOnQuadraticBezier(t, 0,0, 20,-50, -10,-80);
        const normal = getNormalOnQuadraticBezier(t, 0,0, 20,-50, -10,-80);
        ctx.beginPath();
        ctx.moveTo(p.x - normal.x * 10, p.y - normal.y * 10);
        ctx.lineTo(p.x + normal.x * 10, p.y + normal.y * 10);
        ctx.stroke();
    }

    ctx.restore(); // Tail translate

    ctx.restore(); // Main save
};
